export default __webpack_public_path__ + "static/telemed-737449d8d7f83316debce14fde5f0c6f.jpeg";